<template>
    <SimpleLayout>
        <div class="container-nzidoo my-3">
            <LoadingSpinner v-if="loader" />

            <div v-else>
                <!-- Header -->
                <div class="header mb-4">
                    <h1 class="mt-3">
                        {{ $t("sentence.batchOrder") }}
                        <span class="text-muted h5">({{ productsBatch.length }} {{ $t("sentence.items") }})</span>
                    </h1>
                </div>

                <!-- Products Grid -->
                <div class="row mb-4">
                    <div class="col-3 col-md-2 align-items-stretch d-flex" v-for="product in productsBatch"
                        :key="product.id">
                        <ProductMini :product="product" />
                    </div>
                </div>

            </div>

            <!-- Fixed Bottom Actions -->
            <div class="fixed-bottom-actions">
                <!-- Total Summary -->
                <div class="total-summary-card">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="summary-label">{{ $t("ecommerce.product.totalPrice") }}</span>
                        <span class="summary-total">
                            {{ totalPrice.toFixed(2) | currency(" DA", 0, { symbolOnLeft: false }) }}</span>
                    </div>
                </div>
                <div class="total-summary-card">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="summary-label">{{ $t("sentence.yourOffer") }}</span>
                        <input type="number" min="0" step="0.01" class="form-control offer-input"
                            v-model.number="offerPrice"
                            :placeholder="$t('ecommerce.product.offerPrice') || 'Offer price'" />
                    </div>
                </div>
                <div class="px-2">
                    <div class="action-row">
                        <div class="offer-input-wrapper">
                        </div>
                        <button class="btn btn-make-offer" @click="handleMakeOffer">
                            {{ $t("action.makeAnOffer") }}
                        </button>
                        <button class="btn btn-buy-now" @click="handleBuy">
                            {{ $t("action.buyNow") }}
                        </button>

                    </div>
                </div>
            </div>

            <notifications class="custom-notifications mt-2" group="success" position="top center" />
            <notifications class="custom-notifications mt-2" group="error" position="top center" />
        </div>
    </SimpleLayout>
</template>

<script>
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';
import SimpleLayout from "@/layouts/SimpleLayout.vue";
import ProductMini from '@/components/templates/ProductMini.vue';
import config from "@/config";

export default {
    name: "BatchView",
    components: {
        LoadingSpinner,
        SimpleLayout,
        ProductMini,
    },
    props: {
        seller_id: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            config,
            loader: false,
            offerPrice: null,
        };
    },
    mounted() {
        // If no products in Vuex batch, inform user and go back
        if (!this.$store.state.batch.productsBatch||this.$store.state.batch.productsBatch.length===0) {
            this.goBack();
        }
        // Prefill offer price with total price as a sensible default
        this.offerPrice=this.totalPrice||0;
    },
    computed: {
        authUser() {
            return this.$store.state.user;
        },
        productsBatch() {
            return this.$store.state.batch.productsBatch||[];
        },
        totalPrice() {
            return this.productsBatch.reduce((sum, product) => {
                return sum+(parseFloat(product.price)||0);
            }, 0);
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },

        handleBuy() {
            if (!this.isLoggedIn()) {
                this.$router.push('/login');
                return;
            }
            
            const productIds = this.productsBatch.map(product => product.id);
            
            // Navigate to checkout with batch type and product IDs
            this.$router.push({
                name: 'checkoutOrder',
                params: {
                    type: 'batch',
                    id: productIds.join(',') // Pass comma-separated IDs
                }
            });
        },

        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },

        handleMakeOffer() {
            this.loader=true;
            // Implement message logic
            const productIds=this.productsBatch.map(product => product.id);
            // send the user's offer price (fallback to 0)
            const priceToSend=parseFloat(this.offerPrice)||0;

            this.$axios.post('/batch/create', {
                products_id: productIds,
                price: priceToSend,
                text: `${priceToSend}`,
            }).then((res) => {
                this.$router.push({ name: 'messenger', params: { id: res.data.data.to } });
            })
                .catch(err => {
                    console.error("Error fetching user profile:", err);
                })
                .finally(() => {
                    this.loader=false;
                });
        },

    }
};
</script>

<style scoped>
.btn-outline:hover {
    background: white;
}

/* Header */
.header h1 {
    font-size: 24px;
    font-weight: 600;
    color: var(--color-dark);
}

/* Total Summary Card */
.total-summary-card {
    background: var(--gray-100);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
}

.summary-label {
    font-size: 18px;
    font-weight: 500;
    color: var(--color-6);
}

.summary-total {
    font-size: 24px;
    font-weight: 700;
    color: var(--color-primary);
}

.action-row {
    display: flex;
    gap: 8px;
}

/* Offer input styling */
.offer-input-wrapper {
    display: flex;
    align-items: center;
}

.offer-input {
    width: 140px;
    font-size: 20pt;
    padding: 6px 8px;
}

.btn-lg {
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 600;
}

/* Responsive Design */
@media (max-width: 576px) {
    .product-title {
        font-size: 9px;
    }

    .product-price {
        font-size: 9px;
    }

    .summary-label {
        font-size: 16px;
    }

    .summary-total {
        font-size: 20px;
    }

    .btn-lg {
        padding: 12px 20px;
        font-size: 14px;
    }

    .action-row button i {
        display: none;
        /* Hide icons on mobile for space */
    }
}
</style>